import {FormattedMessage, injectIntl} from "react-intl";

const InjectMassage = props => <FormattedMessage {...props}>{props.children}</FormattedMessage>
export default injectIntl(InjectMassage, {
  withRef: false
});
